import { DefaultHttpClient, HttpClient, HttpRequest, HttpResponse, NullLogger } from '@microsoft/signalr';

import { ensureFreshAccessToken } from './tokenRefresh';
import { isAzureSignalRServiceUrl } from './signalRUrl';
import { IState } from '../reducers';

type TokenStore = {
    getState: () => IState;
    dispatch: (action: unknown) => unknown;
};

export { isAzureSignalRServiceUrl } from './signalRUrl';

export class AppAccessTokenHttpClient extends HttpClient {
    private readonly inner: DefaultHttpClient;
    private readonly store: TokenStore;

    constructor(store: TokenStore) {
        super();
        this.inner = new DefaultHttpClient(NullLogger.instance);
        this.store = store;
    }

    public async send(request: HttpRequest): Promise<HttpResponse> {
        if (!request.headers) {
            request.headers = {};
        }

        if (!isAzureSignalRServiceUrl(request.url)) {
            const token = await ensureFreshAccessToken(this.store);
            if (token) {
                request.headers.Authorization = `Bearer ${token}`;
            }
        }

        return this.inner.send(request);
    }

    public getCookieString(url: string): string {
        return this.inner.getCookieString(url);
    }
}
